/**
 * @author Joshmar Morales
 */ const $d27dbe10f1bffb7d$export$95244b523a2a97ee = "https://api.open-meteo.com/v1/forecast";
const $d27dbe10f1bffb7d$export$5c6ccb0fde57a2eb = "https://api.positionstack.com/v1/";
const $d27dbe10f1bffb7d$export$ae65ca51f0d9d16 = "d45ca5aa31996c203812a3c3893b8937";
const $d27dbe10f1bffb7d$export$a213ccb1598f1169 = "kuc08Xj5oVvWRhur9CeUexspdu7j_fd64Zv7_2d36lI";
const $d27dbe10f1bffb7d$export$b1e2e8fe8dcc8589 = 36.1716; // Default latitude for Las Vegas
const $d27dbe10f1bffb7d$export$d25035272c7a1f0e = -115.1391; // Default longitude for Las Vegas


const $453e34c0bc71ab7e$export$ca000e230c0caa3e = {
    image: "",
    city: "",
    country: "",
    forecast: {}
};
/**
 * Change the time format from military to standard
 * @param {Date} date
 * @returns {string}
 */ const $453e34c0bc71ab7e$var$changeToStandardTime = function(date) {
    let hours, minutes, format;
    hours = date.getHours();
    minutes = date.getMinutes();
    format = hours >= 12 ? "PM" : "AM";
    hours = hours % 12; // AM - PM format
    hours = hours ? hours : 0; // Displays 0 as 12 for noon
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + format;
};
/**
 * Creates forecast object to store in the state
 * @param {Object} data
 */ const $453e34c0bc71ab7e$var$createForecast = function(data) {
    // TEMPERATURES
    const temperatureUnits = data.current_units.apparent_temperature;
    const avgTemp = `${Math.round(data.current.apparent_temperature)}${temperatureUnits}`;
    const maxTemp = Math.round(Math.max(...data.daily.apparent_temperature_max)) + temperatureUnits;
    const minTemp = Math.round(Math.max(...data.daily.apparent_temperature_min)) + temperatureUnits;
    // OTHER FORECAST PROPERTIES
    const cloudCover = `${data.current.cloud_cover}${data.current_units.cloud_cover}`;
    const precip = `${data.current.precipitation}${data.current_units.precipitation.slice(0, 2)}`;
    const humid = `${data.current.relative_humidity_2m}${data.current_units.relative_humidity_2m}`;
    const uv = Math.max(...data.daily.uv_index_max) + "";
    const wind = Math.max(...data.daily.wind_speed_10m_max) + data.daily_units.wind_speed_10m_max;
    const snow = `${data.current.snowfall}${data.current_units.snowfall.slice(0, 2)}`;
    // Set sunrise and sunset hours to 12 hour format
    const sunriseOne = $453e34c0bc71ab7e$var$changeToStandardTime(new Date(data.daily.sunrise[0]));
    const sunsetOne = $453e34c0bc71ab7e$var$changeToStandardTime(new Date(data.daily.sunset[0]));
    $453e34c0bc71ab7e$export$ca000e230c0caa3e.forecast = {
        temperature: avgTemp,
        cloudCoverage: cloudCover,
        precipitation: precip,
        humidity: humid,
        maxTemperature: maxTemp,
        minTemperature: minTemp,
        sunrise: sunriseOne,
        sunset: sunsetOne,
        uvIndex: uv,
        windSpeed: wind,
        snowfall: snow
    };
};
const $453e34c0bc71ab7e$export$5c84d93a621d8d80 = async function(lat, long, city = "Las Vegas", country = "United States", imageUrl = "../../assets/images/beach.jpg") {
    try {
        const url = `${(0, $d27dbe10f1bffb7d$export$95244b523a2a97ee)}?latitude=${lat}&longitude=${long}&current=temperature_2m,relative_humidity_2m,apparent_temperature,precipitation,snowfall,cloud_cover&daily=apparent_temperature_max,apparent_temperature_min,sunrise,sunset,uv_index_max,wind_speed_10m_max&temperature_unit=fahrenheit&wind_speed_unit=mph&precipitation_unit=inch&timezone=auto`;
        const res = await fetch(url);
        if (!res.ok) throw new Error("Error in extracting data from URL");
        const data = await res.json();
        $453e34c0bc71ab7e$export$ca000e230c0caa3e.city = city;
        $453e34c0bc71ab7e$export$ca000e230c0caa3e.country = country;
        $453e34c0bc71ab7e$export$ca000e230c0caa3e.image = imageUrl;
        $453e34c0bc71ab7e$var$createForecast(data);
    } catch (err) {
        console.error(`${err} \u{1F354}`);
    }
};



class $94ba5c18299dcf55$var$WeatherView {
    _data;
    _headerEl = document.querySelector(".card__header");
    _cardEl = document.querySelector(".card");
    _bodyItem1 = document.querySelector(".card__body-item-1");
    _bodyItem2 = document.querySelector(".card__body-item-2");
    _bodyItem3 = document.querySelector(".card__body-item-3");
    _bodyItem4 = document.querySelector(".card__body-item-4");
    _bodyItem5 = document.querySelector(".card__body-item-5");
    _bodyItem6 = document.querySelector(".card__body-item-6");
    _bodyItem7 = document.querySelector(".card__body-item-7");
    _bodyItem8 = document.querySelector(".card__body-item-8");
    _searchBox = document.querySelector(".card__search-box");
    _searchBtn = document.querySelector(".card__search-btn");
    _errorMessage = "Unable to output header content";
    addHandlerRender(handler) {
        handler();
    }
    addHandlerSearch(handler) {
        this._searchBtn.addEventListener("click", (e)=>{
            e.preventDefault();
            const city = this.capitalizeCity(this._searchBox.value);
            this._searchBox.value = "";
            handler(city);
        });
        this._searchBox.addEventListener("keydown", (e)=>{
            if (e.key === "Enter") {
                const city = this.capitalizeCity(this._searchBox.value);
                this._searchBox.value = "";
                handler(city);
            }
        });
    }
    render(data) {
        this._data = data;
        this._generateMarkup();
    }
    update(data) {
        this._data = data;
        this._headerEl.removeChild(this._headerEl.lastElementChild);
        for(let i = 0; i < 2; ++i)this._clearMarkup();
        this._generateMarkup();
    }
    capitalizeCity(city) {
        const formattedCity = city.toLowerCase().split(" ").map((s)=>s.charAt(0).toUpperCase() + s.substring(1)).join(" ");
        return formattedCity;
    }
    _clearMarkup() {
        this._headerEl.removeChild(this._headerEl.lastElementChild);
        this._bodyItem1.removeChild(this._bodyItem1.lastElementChild);
        this._bodyItem2.removeChild(this._bodyItem2.lastElementChild);
        this._bodyItem3.removeChild(this._bodyItem3.lastElementChild);
        this._bodyItem4.removeChild(this._bodyItem4.lastElementChild);
        this._bodyItem5.removeChild(this._bodyItem5.lastElementChild);
        this._bodyItem6.removeChild(this._bodyItem6.lastElementChild);
        this._bodyItem7.removeChild(this._bodyItem7.lastElementChild);
        this._bodyItem8.removeChild(this._bodyItem8.lastElementChild);
    }
    /**
   * Changes the background image of the card and the weather forecast values
   */ _generateMarkup() {
        // Change background image based on passed imageURL from Unsplash
        this._cardEl.style.backgroundImage = `
      linear-gradient(
        0deg,
        rgba(101, 60, 103, 0.65) 0%,
        rgba(161, 62, 92, 0.65) 39%,
        rgba(177, 80, 55, 0.65) 100%
      ),
      url('${this._data.image}')
    `;
        const headerMarkup = `
      <p class="paragraph-1">${this._data.city}, ${this._data.country}</p>
      <h2 class="heading-2">${this._data.forecast.temperature}</h2>
      <p class="paragraph-1">L: ${this._data.forecast.minTemperature} &nbsp; H: ${this._data.forecast.maxTemperature}</p>
    `;
        this._headerEl.insertAdjacentHTML("beforeend", headerMarkup);
        let bodyMarkup = `
      <p class="card__forecast-value">${this._data.forecast.cloudCoverage}</p>
      <p class="card__forecast-title">Cloud Coverage</p>
    `;
        this._bodyItem1.insertAdjacentHTML("beforeend", bodyMarkup);
        bodyMarkup = `
      <p class="card__forecast-value">${this._data.forecast.humidity}</p>
      <p class="card__forecast-title">Humidity</p>
    `;
        this._bodyItem2.insertAdjacentHTML("beforeend", bodyMarkup);
        bodyMarkup = `
      <p class="card__forecast-value">${this._data.forecast.precipitation}</p>
      <p class="card__forecast-title">Precipitation</p>
    `;
        this._bodyItem3.insertAdjacentHTML("beforeend", bodyMarkup);
        bodyMarkup = `
      <p class="card__forecast-value">${this._data.forecast.uvIndex}</p>
      <p class="card__forecast-title">UV Index</p>
    `;
        this._bodyItem4.insertAdjacentHTML("beforeend", bodyMarkup);
        bodyMarkup = `
      <p class="card__forecast-value">${this._data.forecast.windSpeed}</p>
      <p class="card__forecast-title">Wind Speeds</p>
    `;
        this._bodyItem5.insertAdjacentHTML("beforeend", bodyMarkup);
        bodyMarkup = `
      <p class="card__forecast-value">${this._data.forecast.snowfall}</p>
      <p class="card__forecast-title">Snowfall</p>
    `;
        this._bodyItem6.insertAdjacentHTML("beforeend", bodyMarkup);
        bodyMarkup = `
      <p class="card__forecast-value">${this._data.forecast.sunrise}</p>
      <p class="card__forecast-title">Sunrise</p>
    `;
        this._bodyItem7.insertAdjacentHTML("beforeend", bodyMarkup);
        bodyMarkup = `
      <p class="card__forecast-value">${this._data.forecast.sunset}</p>
      <p class="card__forecast-title">Sunset</p>
    `;
        this._bodyItem8.insertAdjacentHTML("beforeend", bodyMarkup);
    }
}
var $94ba5c18299dcf55$export$2e2bcd8739ae039 = new $94ba5c18299dcf55$var$WeatherView();


/**
 * Grabs an image from the Unsplash API using the city as a query
 * @param {String} city
 * @returns {String} URL of the image
 */ const $a276606d47f15aed$var$grabCityImage = async function(city) {
    try {
        const unsplashRes = await fetch(`https://api.unsplash.com/search/photos?query=${city} City&client_id=${(0, $d27dbe10f1bffb7d$export$a213ccb1598f1169)}`);
        if (!unsplashRes.ok) throw new Error("Unsplash API not able to grab image");
        const unsplashData = await unsplashRes.json();
        const imageUrl = unsplashData.results[0].urls.regular;
        return imageUrl;
    } catch (err) {
        console.error(`${err} \u{1F3D9}\u{FE0F}`);
    }
};
/**
 * Initial controller function that calls the loading of the weather forecast
 */ const $a276606d47f15aed$var$controlHeader = async function() {
    try {
        // Use default coordinates if the user doesn't want their location shared
        let lat = (0, $d27dbe10f1bffb7d$export$b1e2e8fe8dcc8589);
        let long = (0, $d27dbe10f1bffb7d$export$d25035272c7a1f0e);
        // Grab user's coordinates from the beginning
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition((position)=>{
            lat = position.coords.latitude;
            long = position.coords.longitude;
        });
        // Use reverse geocoding initially
        const url = `${(0, $d27dbe10f1bffb7d$export$5c6ccb0fde57a2eb)}reverse?access_key=${(0, $d27dbe10f1bffb7d$export$ae65ca51f0d9d16)}&query=${lat},${long}`;
        const res = await fetch(url);
        const { data: data } = await res.json();
        // Grabs city and country name
        const city = data[0].locality ? data[0].locality : data[0].region;
        const country = data[0].country;
        // Grabs image url based on city name
        const image = await $a276606d47f15aed$var$grabCityImage(city);
        // Loads the forecast for the specified location
        await $453e34c0bc71ab7e$export$5c84d93a621d8d80(lat, long, city, country, image);
        // Renders the new information on the page
        (0, $94ba5c18299dcf55$export$2e2bcd8739ae039).render($453e34c0bc71ab7e$export$ca000e230c0caa3e);
        if (!res.ok) throw new Error("City does not exist in the world");
    } catch (err) {
        console.error(`${err} \u{1F3AE}`);
    }
};
/**
 * Main controller function that changes the application's image and values
 * depending on what city the user searches for
 * @param {String} city
 */ const $a276606d47f15aed$var$controlSearch = async function(city) {
    try {
        if (!city) throw new Error("City is undefined");
        // Forward geocoding to grab coordinates from the city name
        const url = `${(0, $d27dbe10f1bffb7d$export$5c6ccb0fde57a2eb)}forward?access_key=${(0, $d27dbe10f1bffb7d$export$ae65ca51f0d9d16)}&query=${city}'`;
        const res = await fetch(url);
        if (!res.ok) throw new Error("City does not exist in the world");
        // Grabs coordinates and country name
        const { data: data } = await res.json();
        const lat = data[0].latitude;
        const long = data[0].longitude;
        const country = data[0].country;
        // Grabs image url based on city name
        const image = await $a276606d47f15aed$var$grabCityImage(city);
        // Loads the forecast for the specified location
        await $453e34c0bc71ab7e$export$5c84d93a621d8d80(lat, long, city, country, image);
        // Renders the new information on the page
        (0, $94ba5c18299dcf55$export$2e2bcd8739ae039).update($453e34c0bc71ab7e$export$ca000e230c0caa3e);
    } catch (err) {
        console.error(`${err} \u{1F579}\u{FE0F}`);
    }
};
const $a276606d47f15aed$export$212403aceb100fc4 = function() {
    (0, $94ba5c18299dcf55$export$2e2bcd8739ae039).addHandlerRender($a276606d47f15aed$var$controlHeader);
    (0, $94ba5c18299dcf55$export$2e2bcd8739ae039).addHandlerSearch($a276606d47f15aed$var$controlSearch);
};


const $e73bf42412feb220$var$init = function() {
    (0, $a276606d47f15aed$export$212403aceb100fc4)();
};
$e73bf42412feb220$var$init();


//# sourceMappingURL=index.f866490c.js.map
